<template>
  <textarea ref="inputBox" v-model="model" class="styled-scrollbar" rows="1" />
</template>
<script setup lang="ts">
  const inputBox = ref<HTMLBaseElement>()
  const model = defineModel({ default: '' })

  const handleResize = () => {
    const textarea = inputBox.value
    if (textarea) {
      textarea.style.height = 'auto'
      textarea.style.height = textarea.scrollHeight + 4 + 'px'
    }
  }
  if (navigator.userAgent.toLowerCase().includes('firefox')) {
    watch(
      model,
      () => {
        nextTick(() => {
          const textarea = inputBox.value
          if (textarea) {
            // Firefox has a bug that textarea height is not updated for the placeholder multiple lines
            if (model.value.length === 0) {
              textarea.style.height = 42 + 'px'
            } else {
              handleResize()
            }
          }
        })
      },
      { immediate: true }
    )
  } else {
    watch(
      model,
      () => {
        nextTick(() => {
          handleResize()
        })
      },
      { immediate: true }
    )
  }
</script>
<style lang="scss" scoped>
  textarea {
    outline: none;
    padding: 7px 9px;
    border-radius: 5px;
    background-color: white;
    resize: none;
    overflow-y: auto;
    max-height: 50vh;

    width: 100%;
    vertical-align: top;
    color: #546e7a;
    &::placeholder {
      color: #b0bec5;
    }
  }
</style>
